export function toQueryString<T extends Record<string, any>>(obj: T): string {
  return new URLSearchParams(
    Object.entries(obj).filter(([_, value]) => value !== undefined),
  ).toString();
}
